module.exports = __webpack_public_path__ + "static/block8-ef6ab16e2b5b9854a89a37632eb283ed.jpg";